import { api } from "../api";
import { store } from "../store";
import * as HelperSrc from "../HelperSrc";

async function getMe(): Promise<HelperSrc.UserStore | null> {
    const result: HelperSrc.UserStore | null = api.userApi ? ((await api.userApi.getMe()) as HelperSrc.UserStore) : null;

    if (result) {
        store.setUser({
            ...store.user,
            username: result.username,
            id: result.id,
            is_superuser: result.is_superuser,
            is_staff: result.is_staff,
            is_support: result.is_support,
            groupnames: result.groupnames,
            last_activity: result.last_activity
        });

        localStorage.setItem(`${HelperSrc.LABEL}_groupnames`, JSON.stringify(result.groupnames));

        return result;
    }

    return null;
}

export { getMe };
